import { Reveal } from "./Reveal";
import { OverlapDiagram } from "./OverlapDiagram";

export const IntroSection = () => {
  return (
    <section id="about" data-testid="intro-section" className="relative bg-[#FFFFFF] py-16 sm:py-36">
      <div className="max-w-6xl mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="font-mono text-xs tracking-[0.32em] uppercase text-[#C9A24B]">
                01 · Who I am
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.05}>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-ink">
                I follow questions. They've led
                me through <span className="text-[#C9A24B]">technology</span>,{" "}
                <span className="text-[#C9A24B]">product</span>,{" "}
                <span className="text-[#C9A24B]">buildings</span>,{" "}
                <span className="text-[#C9A24B]">simulations</span>,{" "}
                <span className="text-[#6B8F71]">ecosystems</span>, and{" "}
                <span className="text-[#6B8F71]">ink</span>. I'm not done yet.
              </h2>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 sm:mt-28 grid lg:grid-cols-12 gap-8 lg:gap-16 items-center">
            <div className="lg:col-span-5 order-2 lg:order-1">
              <p className="font-mono text-xs tracking-[0.32em] uppercase text-[#6B8F71]">
                The through-line
              </p>
              <h3 className="font-serif text-2xl sm:text-3xl text-ink mt-3 leading-snug">
                Multiple mediums, orbiting one instinct.
              </h3>
              <p className="font-sans text-sm sm:text-base text-ink leading-relaxed mt-4 max-w-md">
                However different the surface, the work always points back to the
                same center: read the system, find the pattern, and give it a form
                people can feel and use.
              </p>
            </div>
            <div className="lg:col-span-7 order-1 lg:order-2">
              <OverlapDiagram />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default IntroSection;
